import instance from '@apis/instance';
import { SliceResponse } from '@models/page';
import {
  GetShopsInMapParams, GetShopsParams, ShopInMapRow, ShopResponse,
} from '@models/shop';

class ShopApi {
  static getShopsInMap(params: GetShopsInMapParams): Promise<ShopInMapRow[]> {
    return instance.get('/shops/map', { params });
  }

  static getShops(params: GetShopsParams): Promise<SliceResponse<ShopInMapRow>> {
    console.log({ params });
    return instance.get('/shops', { params });
  }

  static getShop(shopId: string): Promise<ShopResponse> {
    return instance.get(`/shop/${shopId}`);
  }
}

export default ShopApi;
